import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';
import { ellipsisMultiline } from '@/styles/helpers';

export const Box = styled.div`
  display: grid;
  grid-template-columns: 35px 1fr;
  grid-template-rows: 35px;
  align-items: center;
  margin-top: -7.5px;

  svg {
    justify-self: center;
  }
`;

export const Item = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  height: 55px;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.palette.secondary.border};
  }
`;

export const ComplaintBSHead = styled.div`
  height: 60px;
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 11px;
  justify-content: space-between;
  align-items: baseline;
  align-content: center;
`;

export const ComplaintBSTitle = styled(Typography.Header).attrs({
  $variant: '3',
})`
  ${ellipsisMultiline(1)}
  text-align: center;
`;

export const ComplaintBSSubmit = styled(Button)`
  height: 60px;
  margin-left: auto;
  font-weight: 700;
`;

export const ComplaintBSError = styled.div`
  margin: 10px 0px 11px;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.system.red};
`;
